<template>
  <div class="page">
    <div class="container">
      <div class="card">
        <h1>US Stock Screener</h1>
        <p class="muted">
          US Stock
        </p>

        <div class="grid">
          <div>
            <label>Symbol</label>
            <input v-model="form.symbol" type="text" placeholder="เช่น PTT" />
          </div>

          <div>
            <label>RSI Period</label>
            <input v-model.number="form.rsiPeriod" type="number" />
          </div>

          <div>
            <label>EMA Short</label>
            <input v-model.number="form.emaShortPeriod" type="number" />
          </div>

          <div>
            <label>EMA Long</label>
            <input v-model.number="form.emaLongPeriod" type="number" />
          </div>

          <!-- <div>
            <label>BB Period</label>
            <input v-model.number="form.bbPeriod" type="number" />
          </div>

          <div>
            <label>BB Std Dev</label>
            <input v-model.number="form.bbStdDev" type="number" step="0.1" />
          </div> -->

          <div>
            <label>minRsi</label>
            <input v-model.number="form.minRsi" type="number" />
          </div>

          <div>
            <label>maxRsi</label>
            <input v-model.number="form.maxRsi" type="number" />
          </div>
        </div>

        <div class="grid-2 section-gap">
          <div class="subcard">
            <h3>Filter</h3>
            <div class="checkbox-group">
              <label class="checkbox-row">
                <input v-model="form.requireAboveEmaShort" type="checkbox" />
                Price > EMA Short
              </label>

              <label class="checkbox-row">
                <input v-model="form.requireAboveEmaLong" type="checkbox" />
                Price > EMA Long
              </label>

              <!-- <label class="checkbox-row">
                <input v-model="form.notAboveUpperBB" type="checkbox" />
                ราคาไม่สูงกว่า Upper BB
              </label>

              <label class="checkbox-row">
                <input v-model="form.notBelowLowerBB" type="checkbox" />
                ราคาไม่ต่ำกว่า Lower BB
              </label> -->
            </div>
          </div>

          <div class="subcard center-box">
            <div>
              <button @click="scan" :disabled="loading">
                {{ loading ? "loading..." : "scan" }}
              </button>
              <div v-if="error" class="error">{{ error }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="result" class="card">
        <h2>Result</h2>

        <p>
          <strong>{{ result.symbol }}</strong>
          :
          <span :class="result.evaluation.allPass ? 'result-pass' : 'result-fail'">
            {{ result.evaluation.allPass ? "passed" : "failed" }}
          </span>
        </p>

        <div class="metric-grid">
          <div class="metric">
            <div class="label">Close</div>
            <div class="value">{{ fmt(result.close) }}</div>
          </div>

          <div class="metric">
            <div class="label">RSI</div>
            <div class="value">{{ fmt(result.rsi) }} ({{ fmt(result.rsiStatus) }})</div>
          </div>

          <div class="metric">
            <div class="label">BB Position</div>
            <div class="value small">{{ fmt(result.bbPosition) }}</div>
          </div>

          <div class="metric">
            <div class="label">EMA Short</div>
            <div class="value">{{ fmt(result.emaShort) }}</div>
          </div>

          <div class="metric">
            <div class="label">EMA Long</div>
            <div class="value">{{ fmt(result.emaLong) }}</div>
          </div>

          <div class="metric">
            <div class="label">Change</div>
            <div class="value">
              {{ fmt(result.change) }} ({{ fmtPct(result.changePct) }})
            </div>
          </div>
        </div>

        <h3 class="section-title">รายละเอียด Indicator</h3>
        <table>
          <tbody>
            <tr>
              <th>Symbol</th>
              <td>{{ fmt(result.symbol) }}</td>
            </tr>
            <tr>
              <th>วันที่ข้อมูลล่าสุด</th>
              <td>{{ formatDate(result.date) }}</td>
            </tr>
            <tr>
              <th>RSI Status</th>
              <td>{{ fmt(result.rsiStatus) }}</td>
            </tr>
            <tr>
              <th>Upper BB</th>
              <td>{{ fmt(result.bbUpper) }}</td>
            </tr>
            <tr>
              <th>Middle BB</th>
              <td>{{ fmt(result.bbMiddle) }}</td>
            </tr>
            <tr>
              <th>Lower BB</th>
              <td>{{ fmt(result.bbLower) }}</td>
            </tr>
            <tr>
              <th>ราคา vs EMA Short</th>
              <td>{{ emaText(result.priceVsEmaShort, "EMA Short") }}</td>
            </tr>
            <tr>
              <th>ราคา vs EMA Long</th>
              <td>{{ emaText(result.priceVsEmaLong, "EMA Long") }}</td>
            </tr>
          </tbody>
        </table>

        <h3 class="section-title">ผลตรวจเงื่อนไข</h3>
        <table>
          <thead>
            <tr>
              <th>เงื่อนไข</th>
              <th>ผล</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(check, index) in result.evaluation.checks" :key="index">
              <td>{{ check.name }}</td>
              <td :class="check.pass ? 'result-pass' : 'result-fail'">
                {{ check.pass ? "PASS" : "FAIL" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
const API_BASE_URL = "https://stctracker.ponnipa.in.th";

export default {
  name: "App",
  data() {
    return {
      loading: false,
      error: "",
      result: null,
      form: {
        symbol: "AVGO",
        rsiPeriod: 14,
        emaShortPeriod: 20,
        emaLongPeriod: 50,
        bbPeriod: 20,
        bbStdDev: 2,
        minRsi: 40,
        maxRsi: 70,
        requireAboveEmaShort: true,
        requireAboveEmaLong: false,
        notAboveUpperBB: true,
        notBelowLowerBB: false
      }
    };
  },
  methods: {
    fmt(v) {
      return v === null || v === undefined ? "-" : v;
    },
    fmtPct(v) {
      return v === null || v === undefined ? "-" : `${v}%`;
    },
    formatDate(v) {
      if (!v) return "-";
      return new Date(v).toLocaleDateString("th-TH");
    },
    emaText(obj, label) {
      if (!obj) return "-";
      const dir = obj.above ? "สูงกว่า" : "ต่ำกว่า";
      return `${dir} ${label} ${Math.abs(obj.diffPct)}%`;
    },
    async scan() {
      this.loading = true;
      this.error = "";
      this.result = null;

      try {
        const res = await fetch(`${API_BASE_URL}/api/scan`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.form)
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.error || "เกิดข้อผิดพลาด");
        }

        this.result = data;
      } catch (err) {
        this.error = err.message || "เกิดข้อผิดพลาด";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f5f7fb;
  padding: 24px;
  color: #1f2937;
  font-family: Arial, sans-serif;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

.card {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

h1,
h2,
h3 {
  margin-top: 0;
}

.muted {
  color: #6b7280;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.section-gap {
  margin-top: 12px;
}

.subcard {
  margin: 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
}

.center-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

label {
  display: block;
  font-size: 14px;
  margin-bottom: 6px;
  font-weight: 600;
}

input[type="text"],
input[type="number"] {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 8px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

button {
  border: 0;
  background: #2563eb;
  color: #fff;
  padding: 12px 18px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
}

button:hover {
  background: #1d4ed8;
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.result-pass {
  color: #047857;
  font-weight: 700;
}

.result-fail {
  color: #b91c1c;
  font-weight: 700;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-top: 12px;
}

.metric {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px;
}

.metric .label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 6px;
}

.metric .value {
  font-size: 20px;
  font-weight: 700;
}

.metric .value.small {
  font-size: 16px;
}

.section-title {
  margin-top: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
}

th,
td {
  text-align: left;
  padding: 10px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 14px;
}

.error {
  color: #b91c1c;
  font-weight: 700;
  margin-top: 10px;
}

@media (max-width: 900px) {

  .grid,
  .grid-2,
  .metric-grid {
    grid-template-columns: 1fr;
  }
}
</style>